import {
  CREATE_MASTERCLASS_CERTIFICATE,
  CREATE_MASTERCLASS_CERTIFICATE_FAILED,
  CREATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
  DELETE_MASTERCLASS_CERTIFICATE,
  DELETE_MASTERCLASS_CERTIFICATE_FAILED,
  DELETE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
  GET_MASTERCLASS_CERTIFICATE,
  GET_MASTERCLASS_CERTIFICATE_FAILED,
  GET_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
  UPDATE_MASTERCLASS_CERTIFICATE,
  UPDATE_MASTERCLASS_CERTIFICATE_FAILED,
  UPDATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL,
} from '../../types/masterclass/masterclassCertificateTypes';

const INIT_STATE = {
  masterclassCertificates: {
    loading: false,
    error: null,
    data: [],
  },
  createMasterclassCertificateAction: {
    status: 'idle',
    error: null,
    data: {},
  },
  updateMasterclassCertificateAction: {
    status: 'idle',
    error: null,
    data: {},
  },
  deleteMasterclassCertificateAction: {
    status: 'idle',
    error: null,
    data: {},
  },
};

export default (state = INIT_STATE, action) => {
  switch (
    action.type // ------ get_masterclass_certificate ------
  ) {
    case GET_MASTERCLASS_CERTIFICATE:
      return {
        ...state,
        masterclassCertificates: {
          ...state.masterclassCertificates,
          loading: true,
          error: null,
        },
      };
    case GET_MASTERCLASS_CERTIFICATE_SUCCESSFUL:
      return {
        ...state,
        masterclassCertificates: {
          loading: false,
          error: null,
          ...action.payload,
          data:
            action.payload?.data?.map?.((item) => ({
              ...item,
              no_of_assigned: item?.certificate_assign?.length || 0,
            })) || [],
        },
      };
    case GET_MASTERCLASS_CERTIFICATE_FAILED:
      return {
        ...state,
        masterclassCertificates: {
          loading: false,
          data: [],
          ...action.payload,
        },
      };
    // ------ create_masterclass_certificate ------
    case CREATE_MASTERCLASS_CERTIFICATE:
      return {
        ...state,
        createMasterclassCertificateAction: {
          status: 'submitting',
          error: null,
          data: action.payload,
        },
      };
    case CREATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL:
      return {
        ...state,
        createMasterclassCertificateAction: {
          status: 'submitted',
          error: null,
          data: action.payload,
        },
      };
    case CREATE_MASTERCLASS_CERTIFICATE_FAILED:
      return {
        ...state,
        createMasterclassCertificateAction: {
          status: 'failed',
          error: action.payload,
          data: {},
        },
      };
    // ------ update_masterclass_certificate ------
    case UPDATE_MASTERCLASS_CERTIFICATE:
      return {
        ...state,
        updateMasterclassCertificateAction: {
          status: 'submitting',
          error: null,
          data: action.payload,
        },
      };
    case UPDATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL:
      return {
        ...state,
        updateMasterclassCertificateAction: {
          status: 'submitted',
          error: null,
          data: action.payload,
        },
      };
    case UPDATE_MASTERCLASS_CERTIFICATE_FAILED:
      return {
        ...state,
        updateMasterclassCertificateAction: {
          status: 'failed',
          error: action.payload,
          data: {},
        },
      };
    // ------ delete_masterclass_certificate ------
    case DELETE_MASTERCLASS_CERTIFICATE:
      return {
        ...state,
        deleteMasterclassCertificateAction: {
          status: 'submitting',
          error: null,
          data: action.payload,
        },
      };
    case DELETE_MASTERCLASS_CERTIFICATE_SUCCESSFUL:
      return {
        ...state,
        deleteMasterclassCertificateAction: {
          status: 'submitted',
          error: null,
          data: action.payload,
        },
      };
    case DELETE_MASTERCLASS_CERTIFICATE_FAILED:
      return {
        ...state,
        deleteMasterclassCertificateAction: {
          status: 'failed',
          error: action.payload,
          data: {},
        },
      };
    default:
      return {
        ...state,
      };
  }
};
